import gql from 'graphql-tag';

const LIST_INVOICE = gql`
  mutation listInvoice($customerId: String) {
    listInvoice(customerId: $customerId)
  }
`;

export default LIST_INVOICE;
